<div class="modal fade show d-block" tabindex="-1" *ngIf="imageUrl">
  <div class="modal-dialog modal-dialog-prev modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title d-flex flex-column">
          <strong>Template Preview</strong>
          <span
            *ngIf="templateName"
            class="text-muted"
            style="font-size: 14px"
            >{{ templateName }}</span
          >
        </h5>
        <button type="button" class="close" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body text-center template-preview-body">
        <img [src]="imageUrl" class="img-fluid" alt="Preview" />
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade show" *ngIf="imageUrl"></div>
